<template>
  <div>
    <!-- <h4 class="font-weight-bold py-3 mb-4">Account</h4> -->

    <b-card
      no-body
      class="overflow-hidden"
    >

      <div class="row no-gutters row-bordered row-border-light">
        <div class="col-md-3 pt-0">
          <b-list-group
            class="account-settings-links"
            flush
          >
            <b-list-group-item
              button
              :active="curTab === 'profile'"
              @click="curTab = 'profile'"
            >Brukerprofil</b-list-group-item>
       
          </b-list-group>
        </div>

        <div
          class="col-md-9"
          v-if="curTab === 'profile'"
        >
          <b-card-body>
            <h5>Brukerprofil</h5>
            <hr />

            <b-form-group label="Navn">
              <b-input v-model="user.username" />
            </b-form-group>

            <b-form-group label="E-post">
              <b-input
                disabled
                v-model="user.email"
              />
            </b-form-group>

            <b-form-group label="Rettigheter">
              <b-input
                disabled
                v-model="user.role.name"
              />
            </b-form-group>

            <b-form-group label="
                Språk">
              <b-form-select
                v-model="user.language"
                :options="languages"
              ></b-form-select>
            </b-form-group>

            <b-form-group>
              <b-alert
                variant="warning"
                show
                class="mt-3 mb-0"
                v-if="!user.confirmed"
              >
                Your email is not confirmed. Please check your inbox.<br />
                <a href="javascript:void(0)">Resend confirmation</a>
              </b-alert>
            </b-form-group>


            <h5>Endre passord</h5>
            <hr />

            <b-button class="mt-3" v-if="showSuccessAlert != true" variant="primary" @click="sendPasswordLink()">Send e-post med link</b-button>

            <b-alert class="mt-3 font-weight-normal" v-model="showSuccessAlert" variant="success" dismissible>
             E-post med instruksjoner har blitt sendt, vennligst sjekk din innboks.
            </b-alert>

            <b-alert class="mt-3 font-weight-normal" v-model="showErrorAlert" variant="danger" dismissible>
             Noe gikk galt. Vennligst kontakt support@aquaservices.no for hjelp.
            </b-alert>

            <br />
            <br />


          </b-card-body>
        </div>     
      </div>
    </b-card>

    <div class="text-right mt-3">
      <b-btn
        variant="default"
        class="mr-2"
        @click="goDashboard()"
      >Avbryt</b-btn>
      <b-btn
        variant="primary"
        @click="updateUser()"
      >Lagre endringer</b-btn>&nbsp;
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<!-- Page -->

<style src="@/vendor/styles/pages/account.scss" lang="scss"></style>

<script>
import axios from "axios";

export default {
  name: "pages-account-settings",
  metaInfo: {
    title: "Account",
  },
  components: {
    
  },
  data() {
    return {
      user: {
        confirmed: true,
      },
      curTab: "profile",
      isLoading: false,
      fullPage: true,
      oldPassword: "",
      newPassword: "",
      password: "",
      confirmation: "",
      passwordForm: true,
      showSuccessAlert: false,
      showPasswordAlert: false,
      showErrorAlert: false,
      languages: [
        { value: "en", text: "English" },
        { value: "no", text: "Norsk" },
      ],
    };
  },

  methods: {
    getUser() {
      axios
        .get("https://api.eines-as.no/users/me")
        .then((res) => {
          this.user = res.data;
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    updateUser() {
      this.isLoading = true;

      axios
        .put("https://api.eines-as.no/users/" + this.user.id, this.user)
        .then((response) => {
          this.$i18n.locale = this.user.language;

          this.$router.push("/dashboard/home");
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    sendPasswordLink() {

          // Request API.
          axios
            .post('https://api.eines-as.no/auth/forgot-password', {
              email: this.user.email
            })
            .then(response => {
              this.showSuccessAlert = true
              this.passwordForm = false

            })
            .catch(error => {
              this.showErrorAlert = true
            });
    },            
    sendToStrapi() {
      let form = this.$refs["uploadForm"];
      let formData = new FormData();
      let formElements = form.elements;
      let data = {};
      formElements.forEach((currentElement) => {
        if (!["submit", "file"].includes(currentElement.type)) {
          data[currentElement.name] = currentElement.value;
        } else if (currentElement.type === "file") {
          if (currentElement.files.length === 1) {
            const file = currentElement.files[0];
            formData.append(`files.${currentElement.name}`, file, file.name);
          } else {
            for (let i = 0; i < currentElement.files.length; i++) {
              const file = currentElement.files[i];
              formData.append(`files.${currentElement.name}`, file, file.name);
            }
          }
        }
      });
      formData.append("data", JSON.stringify(data));
      axios
        .post("http://localhost:1337/foods", formData)
        .then((res) => console.log(res));
    },
    closeModal() {
      this.$router.push("/dashboard/home");
    },
    goDashboard() {
      this.$router.push("/dashboard/home");
    },
  },
  watch: {
    user: function () {
      this.$i18n.locale = this.user.language;
    },
  },
  mounted: function () {
    return this.$store.getters.userEmail;
  },
  created: function () {
    this.getUser();
  },
};
</script>


<style lang="css">
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  border-color: #e2e2e2;
  background-color: #ffffff;
  color: #801529;
}
</style>